import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { PartnerLocationInfo } from '../fragments';

export default gql`
  mutation updatePartnerLocation($input: PartnerLocationUpdateInput!) {
    updatePartnerLocation(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      partnerLocation {
        ...PartnerLocationInfo
      }
    }
  }
  ${PartnerLocationInfo}
  ${ErrorMessageInfo}
`;
